import React, {  useEffect } from 'react';
import {
  PieChart, Pie, Legend, ResponsiveContainer,Cell
} from 'recharts';
import {Tooltip as TooltipRecharts} from 'recharts';
import {
  IconButton,
  Grid, 
  Paper,
  Tooltip,
  CircularProgress
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

import useStylesMain from '../../../../useStyles';
import socket from '../../../../services/socket';
import Title from '../../../../components/Title';


import { indigo, blue } from '@mui/material/colors';

export default function PizzaChartProductHist(props) {
  const classesMain = useStylesMain()
  const [ProductReason,SetProductReason] = React.useState([])
  useEffect(()=>{
    function askProductReason(propsStores){
      let ids = []
      propsStores.storesDisplayed.forEach((stores)=>{
        ids.push(stores.store_id)
      })
      socket.emit('/vezo/histData/askProductsReason',{ 
                                          'store_id_list': ids,
                                          'date': propsStores.date,
                                          }
                                      ,(data)=>{console.log(data);});
    }

    async function loadProductReason(propsStores){
        askProductReason(propsStores)
        socket.on('/vezo/histData/updateProductReason',(propsStores)=>{
          // When the server sends a updatePaperInfo, it asks for newer intel
          askProductReason(propsStores)
        })  
        socket.on('/vezo/histData/ProductsReason',(data)=>{
          let ids = []
          props.storesDisplayed.forEach((stores)=>{
            ids.push(stores.store_id)
          })
          const result = data.filter(store => ids.includes(store.id) )
          let infoNames = []
          result.forEach((store)=>{
            store.data.forEach((reason)=>{
              infoNames.push(reason)
            })
          }) 
          const result2 = infoNames.reduce((acc,val)=>{
            let compare = acc.findIndex((x)=> x.product===val.product)
            if(compare!==-1){
              acc[compare]["count"] = acc[compare]["count"] +  val.count
            }
            else{
              acc.push(Object.assign({},val))
            }
            return acc
          },[])

          let DatawithColor = []
          result2.forEach((store,index)=>{
            var dataTemp
            if(index%2){
              dataTemp = Object.assign({},store,{"fill":indigo[((index+1)*100)]})
            }
            else{
              dataTemp = Object.assign({},store,{"fill":blue[((index+1)*100)]})
            }
            
            DatawithColor.push(dataTemp)
          })
          SetProductReason(DatawithColor)
        })
        return () => socket.disconnect();
    }

    loadProductReason(props);       
    },
    [props])
    
  return (
    <Grid item xs={12} md={12} lg={6}>
      <Paper className={classesMain.paper}>
        <Grid container spacing={3}  justifyContent={"center"} direction="row">
          <Grid item xs={12} md={2} lg={1}>
            <Tooltip title="Produtos não vendidos das lojas selecionadas somadas durante o período!">
              <IconButton aria-label="Selecionar" size="large">
                <InfoIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={12} md={10} lg={11}>
            <Title>Produtos</Title>
          </Grid>
        </Grid>
          {(ProductReason)?
            <ResponsiveContainer width='100%' height={400}>
                <PieChart width={400} height={400}>
                    <Pie dataKey="count" nameKey="product" data={ProductReason} fill="#8884d8" />
                    {
                        ProductReason.map((entry, index) =>{
                        return(<Cell key={`cell-${index}`} />)})
                    }
                    <TooltipRecharts isAnimationActive={true} />
                    <Legend />
                </PieChart>
            </ResponsiveContainer>
        :
        <div style={{paddingTop:'10px'}}>
          <CircularProgress />
        </div>
        }
      </Paper>
    </Grid>
  );
  
}